module.exports = __webpack_public_path__ + "static/media/user-icon.435170c1.png";